import { SharingEvent } from '@news-mono/web-common'
import React from 'react'
import { Logger } from 'typescript-log'
import { LiveEventPost } from '.'
import { PublishedLiveEventPost } from '../helpers'
import { StyledPinnedPosts } from './LiveEventPinnedPosts.styled'
import { TruncatingContainer } from './utility/TruncatingContainer'

export interface PinnedPostsProps {
    eventTitle: string
    pinned: PublishedLiveEventPost[]
    log: Logger
    adUnitPath: string
    onEvent: (event: SharingEvent) => void
}

export const LiveEventPinnedPosts: React.FC<PinnedPostsProps> = ({
    eventTitle,
    pinned,
    log,
    adUnitPath,
    onEvent,
}) => {
    return (
        <StyledPinnedPosts>
            {pinned.map((post) => (
                <TruncatingContainer
                    key={`pinned-${post.id}`}
                    customStyle={'pinned-post'}
                >
                    <LiveEventPost
                        post={post}
                        eventTitle={eventTitle}
                        log={log}
                        adUnitPath={adUnitPath}
                        onEvent={onEvent}
                        renderIDAnchorTag={false}
                    />
                </TruncatingContainer>
            ))}
        </StyledPinnedPosts>
    )
}
